import React from "react"
import classnames from "classnames"
import { useAppDispatch } from "../../state/hooks"
import { setContactOpen } from "../../state/menus"

export default function ContactButton({ visible }) {
  const dispatch = useAppDispatch()

  return (
    <button
      className={classnames({"hidden md:block": !visible})}
      onClick={() => dispatch(setContactOpen(true))}
    >CONTACT</button>
  )
}